import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EligibilityCriterion } from '@gbr-monorepo/interfaces';

@Component({
    selector: 'app-social-criteria-card',
    templateUrl: './social-criteria-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule]
})
export class SocialCriteriaCardComponent {
    public readonly title = input<string>();
    public readonly subtitle = input<string>();
    public readonly socialCriterias = input<EligibilityCriterion[]>();
}
